// ==============================|| LOGO ICON IMAGE ||============================== //

import vrpLogo from 'assets/images/users/logovrp1.png';
import iberdrolaLogo from 'assets/images/users/logoiberdrola.png';

function resolveArea() {
  try {
    const p = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
    if (p.startsWith('/i')) return 'i';
    if (p.startsWith('/v')) return 'v';
  } catch {}
  try {
    const a = localStorage.getItem('current_area');
    if (a === 'i' || a === 'v') return a;
  } catch {}
  return 'v';
}

export default function LogoIcon() {
  const area = resolveArea();
  const logo = area === 'i' ? iberdrolaLogo : vrpLogo;
  return (
    <img
      src={logo}
      alt="Logo"
      style={{
        height: '35px',
        width: '35px',
        objectFit: 'contain',
        borderRadius: area === 'i' ? '6px' : undefined
      }}
    />
  );
}
